import axios from "axios";
import {config} from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
import genericStore from "../generic_store";

export default {
    namespaced: true,
    state: {
        endpoint: "orders",
        object: "order",
        status: "",
        selected_rows: [],
        header: [],
        list: [],
        page: 1,
        total: 0,
        options: {
            itemsPerPage: 10,
            search: ""
        }
    },
    mutations: {
        ...genericStore.mutations,
        
        request(state) {
            state.status = "loading";
        },
        success(state, data) {
            state.status = "success";

            if (data && data["list"]) {
                state.list = data["list"];
            }

            if (data && data["total"]) {
                state.total = data["total"];
            }
        },
        error(state) {
            state.status = "error";
        },
        options(state, data) {
            state.options = data;
        }
    },
    actions: {
        ...genericStore.actions,
        createCheckout({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                const formData = jsonToFormData(filter, {
                    arrayIndexes: true,
                    excludeNull: true,
                });
                axios
                    .post(config.api_url + state.endpoint + "/create_checkout", formData)
                    .then(response => {
                        commit("success")
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },

        getOrders({commit, state}, options) {
            return new Promise((resolve, reject) => {
                commit("request");

                let filter = {
                    ...options,
                    
                };
                axios
                    .get(config.api_url + state.endpoint + "/get_orders", {params: filter})
                    .then(response => {
                        commit("success", {
                            list: response.data,
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },

        getDetail({commit, state}, options) {
            return new Promise((resolve, reject) => {
                commit("request");

                let filter = {
                    ...options,
                };
                axios
                    .get(config.api_url + "order_detail", {params: filter})
                    .then(response => {
                        commit("success", {
                            list: response.data,
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        }
    },
    getters: {
        ...genericStore.getters,
        status(state) {
            return state.status;
        }
    },
    modules: {}
};
